// The fixed text of a rival page (components/Alternative*). The page's own text is
// in its data file.
export const rivalPage = {
  momentsTitle: "Klap finds",
  momentsHighlight: " the moments worth posting",
  tryIntro: "Don't take our words for it, ",
  tryCta: "try by yourself for free:",
  featuresAttr: "Features that makes Klap better",
  comparing: "Comparing",
  versus: "Klap vs. {name}",
  tryKlap: "Try Klap for free",
  yes: "Yes",
  no: "No",
  sources: "{name} sources:",
  relatedTitle: "Compare Klap with other tools",
  relatedLink: "Klap vs {name}",
  relatedAll: "All AI clipping tool alternatives",
  columns: {
    tool: "Tool",
    startsAt: "Paid plans start at",
    freeOption: "Free option",
    counts: "What plans count",
    posting: "Posting",
    api: "API",
  },
  testimonialsTitle: "What our users say about Klap",
  viewReview: "View review on {platform}",
  watchReview: "Watch review on {platform}",
  userAlt: "{name}, Klap user",
  userWithRoleAlt: "{name} — {role}, Klap user",
  rated: "Rated {rating} out of 5 on {platform}",
  seeRating: "See Klap's {rating} out of 5 rating on {platform}",
  tiktokVideo: "TikTok video",
};
